// extracted by mini-css-extract-plugin
module.exports = {"reviewReviewsChart":"ReviewReviewsChart_reviewReviewsChart__3puSD","reviewReviewsChart__chart":"ReviewReviewsChart_reviewReviewsChart__chart__22973"};